// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { observable, makeObservable } from 'mobx';

// models
import { Quicklink } from 'models';

// data
import { preConfiguredQuicklinks } from '../data/pre-configured-quicklinks';

export class QuicklinkStore extends Store {
  public quicklinks: Quicklink[];

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      quicklinks: observable,
    });
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public fetch(programName: string = '') {
    return this.fetchByProgramName(programName).then((data) => {
      this.quicklinks = data;
    });
  }

  public fetchByProgramName(programName: string): Promise<Quicklink[]> {
    const quicklinks = preConfiguredQuicklinks[programName] ?? preConfiguredQuicklinks['us-vrbo'];

    return Promise.resolve(quicklinks);
  }
}
